<template>
  <section class="c-section c-section--aulavirtual">
    <section class="py-4">
      <div class="container">
        <div class="row gy-4">
          <div class="col-12 col-lg-7">
            <b-skeleton-wrapper :loading="loading.lection">
              <template #loading>
                <div class="row gy-2">
                  <div class="col-12">
                    <b-skeleton width="90%" height="30px"></b-skeleton>
                  </div>
                  <div class="col-12">
                    <b-skeleton-img aspect="16:9"></b-skeleton-img>
                  </div>
                  <div class="col-12">
                    <b-skeleton width="30%" height="30px"></b-skeleton>
                  </div>
                </div>
              </template>

              <div v-if="lection" class="c-aulavirtual">
                <div v-show="lectionPlayer" class="c-video position-relative mb-4">
                  <div id="lectionPlayer" class="plyr__video-embed" v-html="lection.video"></div>
                  <div v-if="automaticPlayer.loading" class="c-autoplay">
                    <div>
                      <p class="fs-16 white text-center mb-2">
                        Siguiente clase en: {{ automaticPlayer.counter }}
                      </p>
                      <div class="d-flex align-items-center">
                        <button
                          class="c-button c-button--primary-ghost me-3"
                          @click="closeNextLection()"
                        >
                          Cancelar
                        </button>
                        <router-link
                          v-if="controls && controls.next"
                          :to="controls.next"
                          class="c-button c-button--primary me-3 d-flex"
                        >
                          <span class="fs-21 d-flex">
                            <Icon icon="material-symbols:play-arrow-rounded"/>
                          </span>
                          Ver Ahora
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-md-flex justify-content-md-between align-items-center mb-4">
                  <h2 class="gray-lightx fs-25 w-sbold mb-md-0">
                    {{lection.title}}
                  </h2>
                  <div class="d-flex justify-content-end">
                    <router-link
                      v-if="controls && controls.prev"
                      :to="controls.prev"
                      class="c-button c-button--primary-ghost me-3"
                    >
                      <span class="d-flex align-items-center">
                        <Icon icon="fluent:previous-16-regular"/>
                      </span>
                    </router-link>
                    <router-link
                      v-if="controls && controls.next"
                      :to="controls.next"
                      class="c-button c-button--primary"
                    >
                      <span class="d-flex align-items-center me-2">
                        <Icon icon="fluent:next-16-regular"/>
                      </span>
                      Siguiente
                    </router-link>
                  </div>
                </div>
                <div class="c-hr c-hr--secondary mb-4"></div>
                <div>
                  <div
                    class="
                      d-flex
                      flex-column
                      flex-md-row
                      align-items-start
                      justify-content-between
                      mb-4"
                    >
                    <!-- <div class="d-flex align-items-center order-2 order-md-1">
                      <figure v-if="lection.specialist" class="c-aulavirtual__profile me-2">
                        <img
                          :src="lection.specialist.avatar ? lection.specialist.avatar.url : ''"
                          alt=""
                          class="w-100 h-100 of--cover"
                        />
                      </figure>
                      <div>
                        <h2 class="gray-lightx fs-16 w-sbold mb-0">
                          {{lection.specialist ? lection.specialist.user_firstname : '-'}}
                          {{lection.specialist ? lection.specialist.user_lastname : '-'}}
                        </h2>
                        <p class="sec-light fs-12 w-regular mb-0">
                          {{lection.specialist ? lection.specialist.job : '-'}}
                        </p>
                      </div>
                    </div> -->
                    <div>
                      <div v-for="(item,i) of lection.specialist" :key="i"
                      class="d-flex align-items-center order-2 order-md-1 mb-3">
                        <figure v-if="item" class="c-aulavirtual__profile me-2">
                          <img
                            :src="item.avatar ? item.avatar.url : ''"
                            alt=""
                            class="w-100 h-100 of--cover"
                          />
                        </figure>
                        <div>
                          <h2 class="gray-lightx fs-16 w-sbold mb-0">
                            {{item ? item.user_firstname : '-'}}
                            {{item ? item.user_lastname : '-'}}
                          </h2>
                          <p class="sec-light fs-12 w-regular mb-0">
                            {{item ? item.job : '-'}}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-items-center order-1 order-md-2 mb-4 mb-md-0">
                      <p class="gray-lightx fs-12 d-flex w-regular mb-0 me-3">
                        <span class="fs-16 d-flex align-items-center me-2">
                          <Icon icon="bx:message"/>
                        </span>
                        {{ totalComments }}
                        <span class="d-none d-md-inline-block ms-1">Comentarios</span>
                      </p>
                      <a
                        href="#"
                        @click.prevent="setLike()"
                        class="c-link c-link--primary flat d-flex
                          justify-content-center align-items-center"
                      >
                        <span class="fs-16 d-flex align-items-center me-2">
                          <Icon v-if="lectionLike" icon="ant-design:heart-filled"/>
                          <Icon v-else icon="akar-icons:heart"/>
                        </span>

                        <span v-if="lection.summary.likes !== 0" class="fs-12 w-regular">
                          {{ lection.summary.likes }}
                        </span>
                        <span
                          class="d-none fs-12 w-regular d-md-inline-block"
                          :class="lection.summary.likes === 0 ? '' : 'ms-1'">
                          {{lection.summary.likes === 0 ? 'Me gusta' : 'les gusta' }}
                        </span>

                        <span v-if="loading.like" class="ms-2">
                          <Icon icon="eos-icons:loading" />
                        </span>
                      </a>
                    </div>
                  </div>

                  <div>
                    <b-tabs>
                      <b-tab active>
                        <template #title>
                          <span class="fs-21">
                            <Icon icon="codicon:list-tree"/>
                          </span>
                          Descripción
                        </template>
                        <div>
                          <div class="c-hr c-hr--secondary mb-4"></div>
                          <p class="fs-16 gray-text w-regular" v-html="lection.description"></p>
                        </div>
                      </b-tab>

                      <b-tab>
                        <template #title>
                          <span class="fs-21">
                            <Icon icon="bx:message"/>
                          </span>
                          Comentarios
                        </template>
                        <div>
                          <div class="c-hr c-hr--secondary mb-4"></div>
                          <div class="mb-4">
                            <p class="gray-lightx fs-16 w-regular">
                              {{totalComments}} Comentarios
                            </p>

                            <Editor
                              type="comment"
                              mode="post"
                            />
                          </div>
                          <div class="mb-4">
                            <div class="row gy-3">
                              <div
                                v-for="comment of commentsData"
                                :key="`comment-${comment.comment_ID}`"
                                class="col-12"
                              >
                                <Comment :body="comment" :thread.sync="commentsData"/>
                              </div>
                            </div>

                            <button
                              v-if="comments.paged != -1"
                              @click="getComments()"
                              class="c-button c-button--primary-ghost w-100 mt-4"
                              :class="{loading : loading.moreComments}"
                              :disabled="loading.moreComments"
                            >
                              <p
                                class="mb-0 w-100 d-flex justify-content-center align-items-center"
                              >
                                Cargar más comentarios

                                <span v-if="loading.moreComments" class="c-button__spinner ms-2">
                                  <Icon icon="eos-icons:loading" />
                                </span>
                              </p>
                            </button>
                          </div>
                        </div>
                      </b-tab>

                      <b-tab>
                        <template #title>
                          <span class="fs-21">
                            <Icon icon="fluent:document-copy-20-regular"/>
                          </span>
                          Recursos
                        </template>
                        <div>
                          <div
                            v-for="(resource, iresource) of lection.resources"
                            :key="`resource-${iresource}`"
                            class="c-comment__recurse mb-4"
                          >
                            <h2 class="c-comment__recurse-title white fs-25 w-medium mb-3">
                              {{resource.resource.title}}
                            </h2>
                            <a :href="resource.resource.url" target="_blank" class="c-link">
                              <span class="fs-21 me-1">
                                <template
                                  v-if="filesIconsSupported.includes(resource.resource.subtype)"
                                >
                                  <Icon
                                    :icon="`ph:file-${resource.resource.subtype == 'jpeg'
                                      ? 'jpg'
                                      : resource.resource.subtype}`"
                                  />
                                </template>
                                <template v-else>
                                  <Icon icon="ph:file"/>
                                </template>
                              </span>
                              Descargar recurso
                            </a>
                          </div>
                        </div>
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
              </div>
            </b-skeleton-wrapper>
          </div>
          <div class="col-12 col-lg-5">
            <section class="mb-4">
              <b-skeleton-wrapper :loading="modules.isLoading">
                <template #loading>
                  <div class="c-modules">
                    <div class="row gy-2">
                      <div class="col-12">
                        <div class="c-modules__title pt-2 pb-4 mb-4">
                          <div class="d-flex">
                            <span class="d-flex fs-25 gray-lightx align-items-start">
                              <Icon icon="mdi-light:folder-multiple"/>
                            </span>
                            <h2 class="fs-21 gray-lightx w-sbold mb-0 ms-2">
                              Módulos
                            </h2>
                          </div>
                          <span class="w-sbold">
                            <b-skeleton width="100px" height="30px"></b-skeleton>
                          </span>
                        </div>
                      </div>
                      <div class="col-12">
                        <b-skeleton width="100%" height="30px"></b-skeleton>
                      </div>
                      <div class="col-12">
                        <b-skeleton width="100%" height="30px"></b-skeleton>
                      </div>
                      <div class="col-12">
                        <b-skeleton width="100%" height="30px"></b-skeleton>
                      </div>
                    </div>
                  </div>
                </template>

                <div class="c-modules">
                  <div class="c-modules__title pt-2 pb-4 mb-4">
                    <div class="d-flex">
                      <span class="d-flex fs-25 gray-lightx align-items-start">
                        <Icon icon="mdi-light:folder-multiple"/>
                      </span>
                      <h2 class="fs-21 gray-lightx w-sbold mb-0 ms-2">
                        Módulos
                      </h2>
                    </div>
                    <span class="fs-21 gray-lightx w-sbold">
                      {{modules.duration.h}}h {{modules.duration.m}}m
                    </span>
                  </div>

                  <div class="c-modules__lections">
                    <div class="row gy-3">
                      <div
                        v-for="(module, imodule) of modules.data"
                        :key="`module-${imodule}`"
                        class="col-12"
                      >
                        <div
                          class="c-accordion"
                        >
                          <button
                            @click="module.opened = !module.opened"
                            class="c-accordion__button"
                          >
                            {{imodule + 1}}. {{module.title}}
                          </button>
                          <b-collapse
                            v-model="module.opened"
                            class="c-accordion__li"
                          >
                            <div
                              v-for="(lection, ilection) of module.lections"
                              :key="`lection-${imodule}-${ilection}`"
                              class="w-100 d-flex justify-content-between my-3"
                            >
                              <router-link
                                :to="getLectionURL(imodule + 1, lection)"
                                class="c-accordion__text flat c-link d-flex sec-light"
                                :class="{completed : checkCompletedLection(imodule + 1, lection)}"
                              >
                                <span class="ms-2 fs-14">
                                  <Icon icon="ion:ellipse"/>
                                </span>
                                <p class="mb-0 ms-2">
                                  {{imodule + 1}}.{{ilection + 1}}
                                  {{lection.title}}
                                </p>
                              </router-link>
                              <span class="fs-16 sec-light">
                                {{lection.time}}
                              </span>
                            </div>
                          </b-collapse>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-skeleton-wrapper>
            </section>

            <b-skeleton-wrapper :loading="loading.related">
              <template #loading>
                <div class="c-modules">
                  <div class="row gy-2">
                    <div class="col-12">
                      <h2 class="fs-25 white w-sbold">
                        Curso Recomendado
                      </h2>
                      <div class="c-hr c-hr--primary mb-4"></div>
                    </div>
                    <div class="col-12">
                      <div class="row gy-2">
                        <div class="col-12">
                          <b-skeleton width="100%" height="130px"></b-skeleton>
                        </div>
                        <div class="col-12">
                          <b-skeleton width="90%" height="20px"></b-skeleton>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <div v-if="related.length">
                <h2 class="fs-25 white w-sbold">
                  Curso Recomendado
                </h2>
                <div class="c-hr c-hr--primary mb-4"></div>

                <Course :body="related[0]" />
              </div>
            </b-skeleton-wrapper>
          </div>
        </div>
      </div>
    </section>

    <b-modal
      id="modalCourseLike"
      hide-footer
      hide-header
      hide-actions
      size="md"
      centered
      :no-close-on-backdrop="true"
    >
      <div class="c-modal-like">
        <div class="container">
          <div class="c-modal-like__container py-4">
            <h2 class="fs-24 w-sbold sec-medium text-center">
              ¿Te gustó el curso?
            </h2>
            <p class="fs-16 w-regular sec-medium text-center">
              Con tu valoración nos ayudas a mejora nuestro contenido,
              Muchas gracias por tu tiempo
            </p>
            <div class="d-flex justify-content-center">
              <button
                @click="setCourseLike(true)"
                class="c-button c-button--primary me-4"
                :class="{loading : loading.courseLike}"
                :disabled="loading.courseLike"
              >
                <p class="mb-0 d-flex justify-content-center align-items-center">
                  Me gustó
                  <span v-if="loading.courseLike" class="c-button__spinner ms-2">
                    <Icon icon="eos-icons:loading" />
                  </span>
                </p>
              </button>
              <button
                @click="setCourseLike(false)"
                class="c-button c-button--white-primary"
                :class="{loading : loading.courseDislike}"
                :disabled="loading.courseDislike"
              >
                <p class="mb-0 d-flex justify-content-center align-items-center">
                  No me gustó
                  <span v-if="loading.courseDislike" class="c-button__spinner ms-2">
                    <Icon icon="eos-icons:loading" />
                  </span>
                </p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modalCourseWarning"
      hide-footer
      hide-header
      hide-actions
      size="md"
      centered
      :no-close-on-backdrop="true"
    >
      <div class="c-modal-like">
        <div class="container">
          <div class="c-modal-like__container py-4">
            <h2 class="fs-24 w-sbold sec-medium text-center">
              No tienes acceso al curso
              <Icon icon="line-md:emoji-frown" />
            </h2>
            <p class="fs-16 w-regular sec-medium text-center">
              Lo sentimos, pero igual nos encantaria que seas parte de esta aventura.
            </p>

            <a :href="checkoutCourseLink" class="c-button c-button--primary">
              ¡Inscribirme ahora!
            </a>
          </div>
        </div>
      </div>
    </b-modal>

    <DeleteCommentModal />
  </section>
</template>

<script>
import Plyr from 'plyr';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'home',
  data() {
    return {
      lection: null,
      lectionLike: false,
      lectionPlayer: null,

      automaticPlayer: {
        loading: false,
        counter: 3,
        interval: null,
      },

      modules: {
        data: [],
        duration: {},
        totalLections: 0,

        isLoading: true,
      },
      progress: [],
      progressVideoTime: null,
      currentViewLection: null,

      related: [],

      editor: {
        isEnable: false,
        isLoading: false,

        textarea: '',
      },
      comments: {
        paged: 1,
      },

      loading: {
        lection: false,
        related: false,
        like: false,
        courseLike: false,
        courseDislike: false,

        comments: false,
        moreComments: false,
      },

      player: null,
    };
  },
  components: {
    Course: () => import(/* webpackChunkName: "course" */'../../components/Course.vue'),
    Editor: () => import(/* webpackChunkName: "editor" */'../../components/lection/Editor.vue'),
    Comment: () => import(/* webpackChunkName: "comment" */'../../components/lection/Comment.vue'),
    DeleteCommentModal: () => import(/* webpackChunkName: "delete-comment-modal" */'../../components/lection/DeleteModal.vue'),
  },
  computed: {
    ...mapState({
      commentsData: (state) => state.thread.comments,
      recentComments: (state) => state.thread.recents,
    }),
    baseLectionRest() {
      return `${process.env.VUE_APP_API}/courses/${this.$route.params.course_id}/modules/${this.$route.params.module_id}/lections/${this.$route.params.lection_slug}`;
    },
    userData() {
      return this.$store.getters.stateUser;
    },
    userAuthToken() {
      return this.$store.getters.token;
    },

    filesIconsSupported() {
      return ['zip', 'pdf', 'jpg', 'png', 'jpeg'];
    },
    totalComments() {
      return this.lection && this.lection.summary
        ? this.lection.summary.comments + this.recentComments
        : 0;
    },

    controls() {
      const controls = this.lection?.controls;
      const courseId = this.$route.params.course_id;

      return this.lection
        ? {
          prev: (this.lection.controls.prev)
            ? `/lections/${courseId}/${controls.prev.module}/${controls.prev.lection}`
            : false,
          next: (this.lection.controls.next)
            ? `/lections/${courseId}/${controls.next.module}/${controls.next.lection}`
            : false,
        }
        : false;
    },
    checkoutCourseLink() {
      return `/checkout/course?ids=${this.$route.params.course_id}`;
    },
  },
  watch: {
    $route() {
      this.comments = {
        data: [],
        recents: [],

        paged: 1,
      };
      this.lectionLike = false;

      this.getLectionData();
      this.getComments();
      this.getCourseProgress();
      this.checkUserLiked();
    },
    progress() {
      this.showCourseLike();
    },
    modules() {
      this.showCourseLike();
    },
  },
  mounted() {
    this.getLectionData();
    this.getModules();
    this.getRelated();
    this.getComments();
    this.getCourseProgress();

    this.checkUserLiked();
  },
  methods: {
    ...mapActions(['fillComments']),

    getLectionData() {
      this.loading.lection = true;
      this.player = null;

      fetch(this.baseLectionRest, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.userAuthToken}`,
        },
      })
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          return res.text().then((text) => { throw new Error(text); });
        })
        .then((response) => {
          if (response.status) {
            this.lection = response.data;
            this.nextLection = this.lection.controls.next.lection;
            this.loading.lection = false;

            this.markAsCompleted();
            this.initPlayer();
          } else {
            this.$bvModal.show('modalCourseWarning');
          }
        })
        .catch((err) => {
          this.$bvModal.show('modalCourseWarning');

          throw err;
        })
        .finally(() => {
          this.loading.lection = false;
        });
    },
    getModules() {
      const request = `${process.env.VUE_APP_API}/courses/${this.$route.params.course_id}/modules`;

      fetch(request)
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.modules = response.data;

            this.modules.data = this.modules.data
              .map((mod) => ({ ...mod, opened: mod.id === Number(this.$route.params.module_id) }));
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.modules.isLoading = false;
        });
    },
    getRelated() {
      this.loading.related = true;

      const request = `${process.env.VUE_APP_API}/courses/${this.$route.params.course_id}/related`;

      fetch(request)
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.related = response.data;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loading.related = false;
        });
    },
    getCourseProgress() {
      const request = `${process.env.VUE_APP_API}/courses/${this.$route.params.course_id}/progress`;

      fetch(request, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.userAuthToken}`,
        },
      })
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.progress = response.data;

            this.showCourseLike();
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {});
    },

    getComments() {
      this.loading.comments = true;
      this.loading.moreComments = true;

      const request = `${this.baseLectionRest}/comments?paged=${this.comments.paged}`;

      fetch(request, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.userAuthToken}`,
        },
      })
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.fillComments(this.commentsData.concat(response.data));

            this.comments.paged += 1;
          } else {
            this.comments.paged = -1;
          }
        })
        .catch((err) => {
          this.comments.paged = -1;

          throw err;
        })
        .finally(() => {
          this.loading.comments = false;
          this.loading.moreComments = false;
        });
    },

    checkUserLiked() {
      const request = `${this.baseLectionRest}/liked`;

      fetch(request, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.userAuthToken}`,
        },
      })
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.lectionLike = Boolean(response.data);
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loading.like = false;
        });
    },
    setLike() {
      this.loading.like = true;

      const request = `${this.baseLectionRest}/likes`;

      fetch(request, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${this.userAuthToken}`,
        },
      })
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.lectionLike = Boolean(response.data.liked);

            if (this.lectionLike) {
              this.lection.summary.likes += 1;
            } else {
              this.lection.summary.likes -= 1;
            }
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loading.like = false;
        });
    },
    showCourseLike() {
      if (this.progress.length > 1 && this.progress.length === this.modules.totalLections) {
        const request = `${process.env.VUE_APP_API}/users/${this.userData.id}/courses/${this.$route.params.course_id}/liked`;

        fetch(request, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${this.userAuthToken}`,
          },
        })
          .then((res) => {
            if (res.status === 201 || res.status < 300) {
              return res.json();
            }

            throw res;
          })
          .then((response) => {
            if (!response.status) {
              this.$bvModal.show('modalCourseLike');
            }
          })
          .catch((err) => {
            throw err;
          })
          .finally(() => {});
      }
    },
    setCourseLike(likeMode) {
      if (likeMode) {
        this.loading.courseLike = true;
      } else {
        this.loading.courseDislike = true;
      }

      const request = `${process.env.VUE_APP_API}/users/${this.userData.id}/courses/${this.$route.params.course_id}/likes`;
      const formData = new FormData();

      formData.append('mode', Number(likeMode));

      fetch(request, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${this.userAuthToken}`,
        },
        body: formData,
      })
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.$bvModal.hide('modalCourseLike');
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loading.courseLike = false;
          this.loading.courseDislike = false;
        });
    },

    markAsCompleted() {
      const request = `${this.baseLectionRest}/completed`;

      fetch(request, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${this.userAuthToken}`,
        },
      })
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.progress.push({
              module: this.$route.params.module_id,
              lection: this.$route.params.lection_slug,
            });
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {});
    },
    checkCompletedLection(module, lection) {
      const isCompleted = this.progress
        .find((pro) => pro.module === module && pro.lection === lection.slug);

      return isCompleted;
    },

    initPlayer() {
      window.setTimeout(() => {
        this.lectionPlayer = new Plyr('#lectionPlayer', {
          controls: [
            'play',
            'pause',
            'progress',
            'current-time',
            'duration',
            'mute',
            'volume',
            'captions',
            'settings',
            'fullscreen',
            'ended',
          ],
          previewThumbnails: false,
          captions: { active: true },
          autoplay: true,
        });

        this.automaticPlayer.loading = false;

        this.lectionPlayer.on('progress', (event) => {
          const instance = event.detail.plyr;

          this.progressVideoTime = {
            current: instance.currentTime,
            duration: instance.duration,
            percent: (instance.currentTime * 100) / instance.duration,
          };
        });

        this.lectionPlayer.on('ended', (event) => {
          const instance = event.detail.plyr;

          this.progressVideoTime = {
            current: instance.duration,
            duration: instance.duration,
            percent: 100,
          };

          if (this.controls && this.controls.next) {
            this.automaticPlayer.loading = true;
            this.automaticPlayer.interval = setInterval(this.timerLection, 1000);
          }
        });

        this.initTrackingTimeWatched();
      }, 200);
    },

    timerLection() {
      if (this.automaticPlayer.counter > 0) {
        this.automaticPlayer.counter -= 1;
      } else if (this.automaticPlayer.counter === 0) {
        clearInterval(this.automaticPlayer.interval);

        this.$router.push({ path: this.controls.next }).catch(() => {});

        this.automaticPlayer.counter = 3;
      }
    },

    closeNextLection() {
      this.automaticPlayer.loading = false;

      clearInterval(this.automaticPlayer.interval);

      this.automaticPlayer.counter = 3;
    },

    getLectionURL(module, lection) {
      return `/lections/${this.$route.params.course_id}/${module}/${lection.slug}`;
    },

    initTrackingTimeWatched() {
      window.setInterval(() => {
        if (this.progressVideoTime) {
          if (this.currentViewLection) {
            if (
              this.progressVideoTime.current > this.currentViewLection.time_watched
            ) {
              this.saveTimeWatched(this.progressVideoTime);
            }
          } else {
            this.saveTimeWatched(this.progressVideoTime);
          }
        }
      }, 5000);
    },
    saveTimeWatched(progress) {
      const time = (progress.percent >= 80) ? progress.duration : progress.current;
      const request = `${this.baseLectionRest}/views`;
      const formData = new FormData();

      formData.append('time_watched', time);

      if (this.currentViewLection) formData.append('view_id', this.currentViewLection.id);

      fetch(request, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${this.userAuthToken}`,
        },
        body: formData,
      })
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            console.log('%cAgro Club [🏡] - Progreso guardado ❤️‍🔥 (in silence...)', 'color: #7DB40D;');

            this.currentViewLection = response.data;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {});
    },
  },
};
</script>
